<template>
  <h3 class="wb-type-heading-xs">
    <wb-counter
      :value="count"
      mode="secondary"
      class="wb-type-copy-secondary"
    ></wb-counter>
    {{ $t('schedule.bookingMatches.counter') }}
  </h3>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'otb-result-counter',
  props: {
    count: Number,
  },
  setup() {
    return {};
  },
});
</script>

<style src="./result-counter.scss" lang="scss"></style>
